
import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import {EventBus} from '@/lib/utils/event-bus';
import WindowManager from '@/app/services/window-manager';
import TMessage from '@/lib/components/message/Message.vue';
import TCheckbox from '@/lib/form/checkbox/Checkbox.vue';
import RecommendedVideos from '@/app/components/RecommendedVideos.vue';
import UpgradeLink from '@/app/components/pricing/UpgradeLink.vue';

@Component({
  name: 'salesforce-integration',
  components: {
    TButton,
    TMessage,
    TCheckbox,
    RecommendedVideos,
    UpgradeLink
  }
})
export default class SalesforceIntegration extends Vue {
  private loaded = false;
  private salesforce: any = {};
  private loader = false;
  private windowManager: WindowManager | undefined = undefined;
  private connecting = false;
  private createMissingContact = false;
  private disconnecting = false;
  private defaultVideos = [];
  private settingsLoader = false;
  private package_installed = false;
  private install_url: string | null = null;

  mounted() {
    apiClient
        .fetchIntegrationSettings()
        .then(data => {
          if (data) {
            Vue.set(this, 'salesforce', data.salesforce);
          }
          this.package_installed = this.salesforce && this.salesforce.packageInstalled;
          this.createMissingContact = this.salesforce && this.salesforce.createContactIfMissing
          this.install_url = data.salesforcePackageInstall
          if (this.salesforce && this.salesforce.connected) {
            apiClient
                .salesforcePackageCheck()
                .then(data => {
                  if (data) {
                    Vue.set(this, 'salesforce', data.salesforce);
                  }
                  this.package_installed = this.salesforce && this.salesforce.packageInstalled;
                  this.install_url = data.salesforcePackageInstall
                })
                .catch(e => {
                  this.$error(e);
                });
          }
          this.loaded = true;
        })
        .catch(e => {
          this.$error(e);
        });
  }

  get sfEnabledForWorkspace() {
    if (!this.$user.workspace) {
      return;
    }
    return (
        (this.$user.workspace.configs &&
            this.$user.workspace.configs.salesforceIntegration)
    );
  }

  get disabledTooltip() {
    return (
        (!this.$user.can('update', 'workspace') ||
            !this.sfEnabledForWorkspace) &&
        (!this.sfEnabledForWorkspace
            ? this.$t('message.not_eligible')
            : this.$t('message.no_access'))
    );
  }

  get canShowIntercom() {
    return (
        this.$user.workspace &&
        this.$user.workspace.configs &&
        this.$user.workspace.configs.showSalesforceIntegration
    );
  }

  refreshPackageCheck(){
    apiClient
        .salesforcePackageCheck()
        .then(data => {
          if (data) {
            Vue.set(this, 'salesforce', data.salesforce);
          }
          this.package_installed = this.salesforce && this.salesforce.packageInstalled;
          this.install_url = data.salesforcePackageInstall
        })
        .catch(e => {
          this.$error(e);
        });
  }

  refreshIntegrationSetting() {
    this.$user
        .loadIntegrationSettings()
        .then(data => {
          if (data) {
            Vue.set(this, 'salesforce', data.salesforce);
            this.package_installed = this.salesforce && this.salesforce.packageInstalled;
            this.createMissingContact = this.salesforce && this.salesforce.createContactIfMissing
          }
        })
        .catch(e => {
          this.$error(e);
        });
  }

  disconnectFromSalesforce() {
    this.disconnecting = true;
    apiClient
        .salesforceDisconnect()
        .then(data => {
          this.disconnecting = false;
          this.refreshIntegrationSetting();
        })
        .catch(e => {
          this.disconnecting = false;
          this.$error(e);
        });
  }

  connectToSalesforce() {
    this.windowManager = new WindowManager();
    this.windowManager.showLoader();
    this.connecting = true;
    apiClient
        .salesforceOauthUrl()
        .then(data => {
          this.windowManager!.open(data.url);
          this.connecting = false;
          EventBus.$on('emit.salesforce_callback_state', this.handleCallbackState);
        })
        .catch(error => {
          this.$error(error);
          this.connecting = false;
          this.windowManager!.close();
          EventBus.$off('emit.salesforce_callback_state', this.handleCallbackState);
        });
  }

  handleCallbackState(data) {
    this.connecting = true;
    apiClient
        .salesforceUpdateDirectCallback(data.query)
        .then(data => {
          this.connecting = false;
          this.refreshIntegrationSetting();
        })
        .catch(error => {
          this.$error(error);
          this.connecting = false;
        });
    EventBus.$off('emit.salesforce_callback_state', this.handleCallbackState);
    this.windowManager!.close();
  }

  update(checked) {
    this.settingsLoader = true;
    apiClient
        .updateSalesforceSettings(checked)
        .then(data => {
          this.refreshIntegrationSetting();
          this.settingsLoader = false;
        })
        .catch(error => {
          this.$error(error);
          this.settingsLoader = false;
        });
  }

  goBack() {
    this.$router.push({
      name: 'integrations'
    });
    return;
  }

  showVideoModal(url) {
    EventBus.$emit('video_tutorial_url', url);
    this.$modal.show('show-video-modal');
  }

  destroyed() {
    EventBus.$off('emit.salesforce_callback_state', this.handleCallbackState);
    if (this.windowManager) {
      this.windowManager!.close();
    }
  }

  get canShowTrial() {
    return this.workspace && !this.workspace.trialEnd;
  }

  openPricing() {
    this.$router.push({
      name: 'pricing_page'
    });
  }
}
